import React from 'react';
import EditVideoPackageComponent from '../../../Components/VideoPackage/EditVideoPackage';

export default function EditVideoPackage() {
    return (
        <div className='page-body'>
            <EditVideoPackageComponent />
        </div>
    );
}